import { useEffect, useState, useRef, useMemo } from "react";
import { useParams } from "react-router-dom";
import { events } from "../../utils/constants";
import ChildMatchTable from "./components/childMatchTable";
import { Input, FilterPanel, Title } from "../../components";
import { FaSearch } from "react-icons/fa";
import createChildMatchService from "./childmatch.service";

import useTableData from "../../hooks/useTableData";

import "./index.css";

export default function ChildMatchPage() {
  const { centreId } = useParams();

  // Create a service instance with the centreId
  const childMatchService = useMemo(() => {
    return createChildMatchService(centreId);
  }, [centreId]);

  const {
    data,
    sortColumn,
    sortType,
    loading,
    activeFilters,
    filtersRef,
    currentPage,
    pageSize,
    totalItems,
    searchTerm,
    handleSortColumn,
    applyFilters,
    getColumnValues,
    setFilterValues,
    getFilterValues,
    handlePageChange,
    handlePageSizeChange,
    handleSearchChange,
  } = useTableData({
    service: childMatchService,
    initialFilters: {
      childId: [],
      winzChildName: [],
      winzSwnNumber: [],
    },
    entityName: "centres",
    serviceUpdateEvent: events.CHILD_MATCHES_UPDATED,
    filterableColumns: ["childId", "winzChildName", "winzSwnNumber"],
    searchableColumns: ["childId", "winzChildName", "winzSwnNumber"],
  });

  const activeFilterColumnKey = useRef(null);
  const [isCheckPickerOpen, setIsCheckPickerOpen] = useState(false);

  const openCheckPickerForColumn = (columnKey) => {
    activeFilterColumnKey.current = columnKey;
    setFilterValues(filtersRef.current[columnKey] || []);
    setIsCheckPickerOpen(true);
  };

  const applyCurrentFilters = () => {
    const selectedValuesFromPanel = getFilterValues();
    filtersRef.current = {
      ...filtersRef.current,
      [activeFilterColumnKey.current]: selectedValuesFromPanel,
    };
    applyFilters();
    setIsCheckPickerOpen(false);
  };

  function onFilterChange(selectedValues) {
    setFilterValues(selectedValues);
  }

  const cancelFiltering = () => {
    setIsCheckPickerOpen(false);
  };

  const getValuesForActiveColumn = () => {
    if (!activeFilterColumnKey.current) return [];
    return getColumnValues(activeFilterColumnKey.current);
  };

  return (
    <div className="child-match-page">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "start", marginBottom: 16, width: "100%" }}>
        <Title text="CHILD MATCHES" />
        <Input
          label="Search"
          value={searchTerm}
          onChange={(e) => handleSearchChange(e.target?.value || "")}
          placeholder="Search child matches..."
          style={{ marginRight: 8, width: 400, marginLeft: "100px" }}
          icon={<FaSearch />}
        />
      </div>
      {isCheckPickerOpen && activeFilterColumnKey.current && (
        <FilterPanel
          activeColumn={activeFilterColumnKey.current}
          filterOptions={getValuesForActiveColumn()}
          selectedValues={filtersRef.current[activeFilterColumnKey.current] || []}
          onApply={applyCurrentFilters}
          onCancel={cancelFiltering}
          onFilterChange={onFilterChange}
        />
      )}
      <ChildMatchTable
        data={data}
        sortColumn={sortColumn}
        sortType={sortType}
        onSortColumn={handleSortColumn}
        loading={loading}
        activeFilters={activeFilters}
        onFilterClick={openCheckPickerForColumn}
        currentPage={currentPage}
        pageSize={pageSize}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        service={childMatchService}
        centreId={centreId}
      />
    </div>
  );
}
